import {
  // Container,
  Box,
  Backdrop,
  Alert,
  Snackbar,
  CircularProgress,
  Typography,
  // Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  // IconButton,
  Icon,
  Divider,
  Dialog,
  DialogContent,
  // DialogContentText,
  // DialogTitle,
  DialogActions,
  // Button,
  TextField,
  // InputAdornment,
  Grid,
  Card,
  Checkbox,
  DialogTitle,
  Button,
} from "@mui/material";
import { CheckBox } from "@mui/icons-material";

import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios.js";
import usePageTitle from "app/pageTitle";
import AppConfig from "appConfig";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";
import Carousel from "react-material-ui-carousel";
import MDBox from "components/MDBox";

function PromoteView() {
  const pageTitle = `Promotion Campaign`;
  usePageTitle(pageTitle);

  const { ref, smmPlatform } = useParams();
  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  async function copy(stringtext) {
    try {
      await navigator.clipboard.writeText(stringtext);
      setErrMsg("Link copied!");
      setSeverity("success");
      setOpen(true);
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  }

  const [description, setDescription] = useState("");
  const [currency, setCurrency] = useState("");
  const [contents, setContents] = useState([]);
  const [platforms, setPlatforms] = useState([]);
  const [authUrl, setAuthUrl] = useState(null);
  const [selectedPlatform, setSelectedPlatform] = useState(null);
  const [shareLink, setShareLink] = useState(null);
  const [openDescriptionDialog, setOpenDescriptionDialog] = useState(false);
  const [openAuthDialog, setOpenAuthDialog] = useState(false);
  const [tosAgree, setTosAgree] = useState(false);

  useEffect(() => {
    if (ref === null) {
      navigate("/error");
      return;
    }

    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`agents/smm/${ref}/fetch.json`)
        .then((result) => {
          console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setDescription(result.data.data.description);
            setCurrency(result.data.data.currency);
            setContents(result.data.data.content);
            setPlatforms(result.data.data.platforms);
            setShareLink(result.data.data.share_link);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  async function getAuthUrl(plat4m) {
    setShowLoading(true);
    const json = {
      reference: ref,
      platform: plat4m,
    };

    // console.log(json);

    await axios
      .post("agents/smm/init.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          // window.location.href = result.data.data.auth_url;
          // window.open(result.data.data.auth_url, '_blank');
          setAuthUrl(result.data.data.auth_url);
          // setCriteria(result.data.data.criteria);
          setOpenAuthDialog(true);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  function getPlatformRow(platform) {
    return (
      <ListItem key={platform.reference} sx={{ py: 1, px: 0, mb: 2 }}>
        <ListItemIcon>
          <img
            src={`${AppConfig.api_media_url}${platform.logo}`}
            alt={platform.title}
            width="36px"
          />
        </ListItemIcon>
        <ListItemText
          sx={{ mr: 2 }}
          primary={
            <Typography variant="subtitle2" fontSize={11} fontWeight={400}>
              {platform.title}: {currency}
              {(platform.commission / 100).toLocaleString("en", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </Typography>
          }
          secondary={
            <Box mt={0.5}>
              <Typography fontSize={10}>
                {`Followers Required: +${platform.min_followers}`}
              </Typography>
              <Typography fontSize={10}>
                Posted:{" "}
                <b>
                  {platform.count} / {platform.target}
                </b>
              </Typography>
            </Box>
          }
        />
        <Box align="right">
          <MDButton
            size="small"
            color="primary"
            startIcon={<Icon>post_add</Icon>}
            onClick={() => {
              getAuthUrl(platform.reference);
              setSelectedPlatform(platform.title);
            }}
          >
            POST
          </MDButton>
        </Box>
      </ListItem>
    );
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Box mb={5}>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={showLoading}
          onClick={handleClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
            {errorMsg}
          </Alert>
        </Snackbar>
        <Dialog open={openDescriptionDialog} fullWidth maxWidth="sm">
          <DialogTitle>About This Advert</DialogTitle>
          <DialogContent>
            <MDBox mb={3} p={2}>
              <div dangerouslySetInnerHTML={{ __html: description }} />
            </MDBox>
          </DialogContent>
          <DialogActions>
            <MDButton
              onClick={() => {
                setOpenDescriptionDialog(false);
              }}
              color="dark"
              variant="outlined"
              iconOnly
              circular
            >
              <Icon>close</Icon>
            </MDButton>
          </DialogActions>
        </Dialog>
        <Dialog open={openAuthDialog} fullWidth maxWidth="xs">
          <DialogContent>
            <Box align="center">
              <Icon color="warning" sx={{ size: 48 }}>
                info
              </Icon>
            </Box>
            <Box align="center">
              <MDTypography variant="h6" fontWeight="medium" fontSize={18}>
                {selectedPlatform}
              </MDTypography>
              <MDTypography variant="h6" fontWeight="regular">
                Please read through our Data Privacy Policies
              </MDTypography>
            </Box>
            <Box mt={3} p={1}>
              <List>
                <ListItem>
                  <ListItemIcon>
                    <CheckBox color="primary" />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography variant="caption" fontSize={12} fontWeight={400}>
                        You are not allowed to delete this post from your profile{" "}
                        <b>before 24 hrs.</b> Doing so will get you banned!
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <CheckBox color="primary" />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <MDTypography variant="caption" fontSize={12} fontWeight={400}>
                        You have previewed the media content and caption properly
                      </MDTypography>
                    }
                  />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <CheckBox color="primary" />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <MDTypography variant="caption" fontSize={12} fontWeight={400}>
                        This post will be viewable to the public
                      </MDTypography>
                    }
                  />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <CheckBox color="primary" />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <MDTypography variant="caption" fontSize={12} fontWeight={400}>
                        This post will allow comments from your network
                      </MDTypography>
                    }
                  />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <CheckBox color="primary" />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <MDTypography variant="caption" fontSize={12} fontWeight={400}>
                        This post will be labelled as Paid Partnership/Promotion
                      </MDTypography>
                    }
                  />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <CheckBox color="primary" />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <MDTypography variant="caption" fontSize={12} fontWeight={400}>
                        This post may take a few minutes to process and be visible on your profile
                      </MDTypography>
                    }
                  />
                </ListItem>
                {/* <ListItem>
                  <ListItemIcon>
                    <CheckBox color="primary" />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <MDTypography variant="caption" fontSize={12} fontWeight={400}>
                        By posting, you agree to the terms and conditions of{" "}
                        <b>{selectedPlatform}</b>
                      </MDTypography>
                    }
                  />
                </ListItem> */}
              </List>
              <Box display="flex" alignItems="center" mt={3} ml={-1}>
                <Checkbox
                  checked={tosAgree}
                  onChange={(e) => {
                    setTosAgree(e.target.checked);
                  }}
                />
                <Typography variant="h6" fontSize={13} fontWeight={400}>
                  By posting, you agree to Laddar Africa&apos;s{" "}
                  <a href="https://laddar.africa/terms">
                    <i>Content & Sharing Terms and Conditions</i>
                  </a>
                  .
                </Typography>
              </Box>
            </Box>
          </DialogContent>
          <DialogActions>
            <MDButton
              onClick={() => {
                setOpenAuthDialog(false);
              }}
              color="dark"
              variant="outlined"
              iconOnly
              circular
            >
              <Icon>close</Icon>
            </MDButton>
            <MDButton
              onClick={() => {
                if (tosAgree === false) {
                  alert(`Please agree to Laddar's content, sharing and usage policies`);
                  return;
                }
                setOpenAuthDialog(false);
                window.open(authUrl, "_blank").focus();
                // window.location.replace(authUrl);
              }}
              color="primary"
              variant="contained"
              iconOnly
              circular
            >
              <Icon>send</Icon>
            </MDButton>
          </DialogActions>
        </Dialog>
        {contents.length > 0 ? (
          <Box mt={3}>
            <Box>
              <Button
                size="small"
                color="dark"
                startIcon={<Icon>west</Icon>}
                onClick={() => {
                  navigate("/promotions");
                }}
              >
                Back
              </Button>
            </Box>
            <Box mt={2}>
              <Card>
                <Box p={2}>
                  <Box mt={2} align="center">
                    <MDTypography fontSize={14} variant="h6" fontWeight="medium">
                      <Icon color="info">info</Icon>
                      <br />
                      Post the advert below on all your social media accounts and earn money
                      instantly.
                    </MDTypography>
                  </Box>
                  <MDBox>
                    <Box mt={5} align="center">
                      <Box
                        sx={{
                          padding: "10px",
                          background: "#D3D3D3",
                          webkitBorderRadius: "15px",
                          borderRadius: "15px",
                          overflow: "hidden",
                        }}
                      >
                        <Carousel
                          autoPlay
                          NextIcon={<Icon>chevron_right</Icon>}
                          PrevIcon={<Icon>chevron_left</Icon>}
                        >
                          {contents.map((content) => (
                            <Box sx={{ minHeight: 260 }}>
                              {content.type === "VIDEO" ? (
                                <iframe
                                  title={content.caption}
                                  type="text/html"
                                  width="100%"
                                  height="320"
                                  src={`${AppConfig.api_media_url}${content.media}`}
                                  frameBorder="0"
                                  allowFullScreen
                                />
                              ) : (
                                <img
                                  src={`${AppConfig.api_media_url}${content.media}`}
                                  alt={content.caption}
                                  width="100%"
                                  height="100%"
                                  // width="320px"
                                />
                              )}
                            </Box>
                          ))}
                        </Carousel>
                      </Box>
                    </Box>
                    <MDBox mt={1} px={1} align="right">
                      <Typography fontSize={12}>Media: {contents.length}</Typography>
                    </MDBox>
                  </MDBox>
                  <Box mt={3}>
                    <Divider />
                  </Box>
                  <Box mt={3} align="center">
                    <Typography fontSize={12}>Advert Information</Typography>
                    <MDTypography mt={1} mb={3} variant="h6" fontWeight="regular">
                      To learn more about this advert. Click the button below.
                    </MDTypography>
                    <MDButton
                      size="small"
                      color="info"
                      onClick={() => setOpenDescriptionDialog(true)}
                    >
                      About this Advert
                    </MDButton>
                  </Box>
                  <Box mt={3}>
                    <Divider />
                  </Box>
                  <Box mt={2}>
                    <List disablePadding>
                      {platforms.map((platform) => {
                        console.log(smmPlatform);
                        if (smmPlatform === null || typeof smmPlatform === "undefined") {
                          return getPlatformRow(platform);
                        }
                        if (smmPlatform === platform.reference) {
                          return getPlatformRow(platform);
                        }
                        return <> </>;
                      })}
                    </List>
                  </Box>
                  {shareLink !== null ? (
                    <>
                      {" "}
                      <Box mt={3}>
                        <Divider />
                      </Box>
                      <Box mt={5} mb={5}>
                        <Box mb={3}>
                          <Typography fontSize={12}>
                            <b>Earn even more!</b>
                            <br />
                            Share your link below with family and friends. You earn <b>30%</b> each
                            time they perform this action using your link. They earn <b>70%</b> too!
                          </Typography>
                        </Box>
                        <Grid container spacing={1}>
                          <Grid item xs={10} md={10} lg={10}>
                            <TextField
                              value={shareLink}
                              readOnly
                              disabled
                              sx={{ width: "100%" }}
                              type="text"
                              name="Share Link"
                              InputProps={
                                {
                                  // startAdornment: (
                                  //   <InputAdornment position="start">
                                  //     <Icon
                                  //       color="primary"
                                  //       onClick={() => {
                                  //         window.open(shareLink, "_blank").focus();
                                  //       }}
                                  //     >
                                  //       public
                                  //     </Icon>
                                  //   </InputAdornment>
                                  // ),
                                  // endAdornment: <InputAdornment position="end"></InputAdornment>,
                                }
                              }
                            />
                          </Grid>
                          <Grid item xs={2} md={2} lg={2}>
                            <Box align="right" sx={{ height: "100%" }}>
                              <MDButton
                                sx={{ width: "100%", height: "100%" }}
                                color="primary"
                                fontSize={12}
                                onClick={() => copy(shareLink)}
                                iconOnly
                                variant="contained"
                              >
                                <Icon>copy</Icon>
                              </MDButton>
                            </Box>
                          </Grid>
                        </Grid>
                      </Box>
                    </>
                  ) : (
                    <> </>
                  )}
                </Box>
              </Card>
            </Box>
          </Box>
        ) : (
          <> </>
        )}
      </Box>
      <Footer />
    </DashboardLayout>
  );
}

export default PromoteView;
